const t = (e, p) => e.depth - p.depth;
export {
  t as compareByDepth
};
